import { LAYERTYPE, FEATURELOADINGSTRATEGY, FrameFeatureLayerEditor, Infra3DLayer } from "./internal";
/**
 * Extension of the Infra3DLayer for the usage of framefeaturecollections in a layer (Anon-boxes).
 * @class FrameFeatureLayer
 * @extends Infra3DLayer
 * @author Joel Burkhard
 *
 */
export class FrameFeatureLayer extends Infra3DLayer {
    constructor(scene, opt_options) {
        super(scene, opt_options);
        this.type = LAYERTYPE.FRAMEFEATURELAYER;
        const options = opt_options || {};
        //set the default strategy for this layer to BBOX
        this.strategy = options.strategy || FEATURELOADINGSTRATEGY.BBOX;
        //Init FrameFeatureCollection. Overrides the featurecolection property of Layer
        const fh = this.scene.getFeatureHandler();
        this.featurecollection = fh.createFeatureCollection(this.style, this.highlightstyle, this.layername, this.selectable, true);
        this.setVisible(this.visible);
        //Init the FrameFeatureLayerEditor. Overrides the layereditor property of Layer
        this.layereditor = new FrameFeatureLayerEditor(this.scene, this);
    }
    /**
     * FrameFeatureLayer-specific implementation of the feature-load-function.
     * For performance reason the features are here loaded without geometry (...&no_geom=true).
     * This function can still be overwritten
     * by a given function 'loadFeatures' in the options.
     * @param extent
     * @param srid
     */
    _loadFeatures_internal(extent, srid) {
        const filters = this._applyFilter();
        const defaultVars = {
            bbox: extent.minx + "," + extent.miny + "," + extent.maxx + "," + extent.maxy,
            requestsrid: srid,
            requestoutputsrid: srid,
            no_geom: true,
        };
        const urlVars = { ...defaultVars, ...filters.queryable, ...filters.fieldquery };
        this.api.readfeatures(this._featureclass, (geojson) => {
            this.addFeatures(geojson);
        }, (message) => {
            console.log(message);
        }, urlVars);
    }
}
//# sourceMappingURL=framefeaturelayer.js.map